/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StatEngineTable_query$ref = any;
export type NFLStatSortByInput = {|
  id: string,
  desc: boolean,
|};
export type NFLStatEnginePaginationQueryVariables = {|
  count?: ?number,
  cursor?: ?string,
  endWeek?: ?number,
  positions?: ?$ReadOnlyArray<?string>,
  seasonID?: ?string,
  sortBy?: ?NFLStatSortByInput,
  startWeek?: ?number,
  weeks?: ?$ReadOnlyArray<?number>,
|};
export type NFLStatEnginePaginationQueryResponse = {|
  +$fragmentRefs: StatEngineTable_query$ref
|};
export type NFLStatEnginePaginationQuery = {|
  variables: NFLStatEnginePaginationQueryVariables,
  response: NFLStatEnginePaginationQueryResponse,
|};
*/


/*
query NFLStatEnginePaginationQuery(
  $count: Int = 1000
  $cursor: String
  $endWeek: Int = 20
  $positions: [String]
  $seasonID: ID
  $sortBy: NFLStatSortByInput
  $startWeek: Int = 1
  $weeks: [Int]
) {
  ...StatEngineTable_query_2hVe8V
}

fragment StatEngineTable_query_2hVe8V on Query {
  nflPlayerWeekStats(startWeek: $startWeek, endWeek: $endWeek, positions: $positions, sortBy: $sortBy, weeks: $weeks, seasonId: $seasonID) {
    headers {
      Header
      accessor
    }
    rows(first: $count, after: $cursor) {
      edges {
        node {
          player {
            firstName
            lastName
            position {
              name
              id
            }
            dkPlayer {
              id
            }
            injuryStatus
            team {
              id
              abbreviation
            }
            id
          }
          stats
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "endWeek"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "seasonID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortBy"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "startWeek"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "weeks"
  }
],
v1 = {
  "kind": "Variable",
  "name": "endWeek",
  "variableName": "endWeek"
},
v2 = {
  "kind": "Variable",
  "name": "positions",
  "variableName": "positions"
},
v3 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v4 = {
  "kind": "Variable",
  "name": "startWeek",
  "variableName": "startWeek"
},
v5 = {
  "kind": "Variable",
  "name": "weeks",
  "variableName": "weeks"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLStatEnginePaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "seasonID",
            "variableName": "seasonID"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "StatEngineTable_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NFLStatEnginePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "seasonId",
            "variableName": "seasonID"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "concreteType": "NFLStatDataType",
        "kind": "LinkedField",
        "name": "nflPlayerWeekStats",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatDataHeader",
            "kind": "LinkedField",
            "name": "headers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "Header",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "NFLStatDataRowConnection",
            "kind": "LinkedField",
            "name": "rows",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatDataRowEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NFLStatDataRowType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NFLStatPlayerType",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NFLStatPositionType",
                            "kind": "LinkedField",
                            "name": "position",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlayerType",
                            "kind": "LinkedField",
                            "name": "dkPlayer",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "injuryStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NFLStatTeamType",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "abbreviation",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stats",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "StatTable_rows",
            "kind": "LinkedHandle",
            "name": "rows"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb262658095e9aa54d2021d86961a9fd",
    "id": null,
    "metadata": {},
    "name": "NFLStatEnginePaginationQuery",
    "operationKind": "query",
    "text": "query NFLStatEnginePaginationQuery(\n  $count: Int = 1000\n  $cursor: String\n  $endWeek: Int = 20\n  $positions: [String]\n  $seasonID: ID\n  $sortBy: NFLStatSortByInput\n  $startWeek: Int = 1\n  $weeks: [Int]\n) {\n  ...StatEngineTable_query_2hVe8V\n}\n\nfragment StatEngineTable_query_2hVe8V on Query {\n  nflPlayerWeekStats(startWeek: $startWeek, endWeek: $endWeek, positions: $positions, sortBy: $sortBy, weeks: $weeks, seasonId: $seasonID) {\n    headers {\n      Header\n      accessor\n    }\n    rows(first: $count, after: $cursor) {\n      edges {\n        node {\n          player {\n            firstName\n            lastName\n            position {\n              name\n              id\n            }\n            dkPlayer {\n              id\n            }\n            injuryStatus\n            team {\n              id\n              abbreviation\n            }\n            id\n          }\n          stats\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b2f85255e04ff7b93c55636e13729c1e';

module.exports = node;
